import React from 'react';
import R from 'ramda';
import SelectDropdown from 'patternity/lib/select_dropdown';
import { compose, withHandlers, defaultProps } from 'recompose';
import { withNamespaces } from 'react-i18next';

const mapWithIndex = R.addIndex(R.map);

const enhance = compose(
  withNamespaces(),
  withHandlers({
    onChange: props => event => {
      const index = parseInt(event.target.value);
      props.onFilterChange(props.challengeStages[index].action, index);
    }
  })
);

const renderOptions = (stages, t) => mapWithIndex((stage, index) =>
  <option key={index} value={`${index}`} id={"challenge-stage-" + stage.title.toLowerCase()}>
    {t('{{stage_title}} Challenges', { stage_title: stage.title, interpolation: {escapeValue: false} })}
  </option>
)(stages);

export default enhance(({ selectedFilterIndex, onChange, challengeStages, t }) =>
  <div>
    <label className="sr-only" htmlFor="challenge-stage-filter-select">{t('Choose stage')}</label>
    <SelectDropdown id="challenge-stage-filter"
        onChange={onChange}
        value={`${selectedFilterIndex}`}>
      { renderOptions(challengeStages, t) }
    </SelectDropdown>
  </div>
);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/stage_filters.jsx